import { EmailInput } from "./EmailInput";
export default EmailInput;
